export const mediaQueries = [
  '(min-width: 3840px)', // 4K Screen
  '(min-width: 2560px) and (max-width: 3839px)', // 1440p Screen
  '(min-width: 1920px) and (max-width: 2559px)', // 1080p Screen
  '(min-width: 1024px) and (max-width: 1439px)', // Laptop Screen
  '(min-width: 768px) and (max-width: 1023px)', // Tablet
  '(max-width: 767px)', // Mobile
]
